import mergeClasses from "glesys-controlpanel/modifiers/merge-classes";
import { LinkTo } from "@ember/routing";
import IconsChevronLeft from "glesys-controlpanel/components/icons/chevron-left";

<template>
  <LinkTo
    class="flex items-center leading-none text-gray-600 hover:text-gray-800 stroke-gray-400 hover:stroke-gray-800"
    data-test-back-to
    @route={{@route}}
    {{mergeClasses}}
    ...attributes
  >
    <IconsChevronLeft class="size-5 stroke-current" data-test-back-to-chevron />
    {{yield}}
  </LinkTo>
</template>
